import { v4 as uuidv4 } from 'uuid';

export const rawPreset = () => {
  return {
    id: uuidv4(),
    type: 'raw',
    attributes: {},
    children: [],
    content: ['<!-- Ваш код -->']
  }
}